import { Link } from "react-router-dom";
import Logo from "../images/logo/logo.png";
import { useState, useEffect } from "react";
import { IconLogout, IconMenu2, IconX } from "@tabler/icons-react";
import { getAuth, signInWithPopup, GoogleAuthProvider, signInAnonymously, onAuthStateChanged } from "firebase/auth";

function Navbar() {
  const [nav, setNav] = useState(false);
  const [loggedin, setLoggedin] = useState(false);
  const auth = getAuth();
  const provider = new GoogleAuthProvider();
  auth.provider = provider;

  const openNav = () => {
    setNav(!nav);
  };

  useEffect(()=>{
    onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/auth.user
        const uid = user.uid;
        console.log("user is logged in");
        console.log(user.email);
        setLoggedin(true);
        // ...
      } else {
        console.log("user is signed out");      
        // User is signed out
        // ...
        signInAnonymously(auth)
        .then(() => {
          setLoggedin(false);
          console.log("Signed in");
          // Signed in..
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log(error.message);
          // ...
        });
      }
    });
  }, []) 

  const handleLogout = () => {
    auth.signOut();
  }

  const handleLogin = () => {
    signInWithPopup(auth, provider)
      .then((result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        const user = result.user;
        console.log(user.email);        
        // IdP data available using getAdditionalUserInfo(result)
        // ...
      }).catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.customData.email;
        // The AuthCredential type that was used.
        const credential = GoogleAuthProvider.credentialFromError(error);
        // ...
      });
  }

  return (
    <>
      <nav>
        {/* mobile */}
        <div className={`mobile-navbar ${nav ? "open-nav" : ""}`}>
          <div onClick={openNav} className="mobile-navbar__close">
            <IconX width={30} height={30} />
          </div>
          <ul className="mobile-navbar__links">
            <li>
              <Link onClick={openNav} to="/">
                Home
              </Link>
            </li>
            <li>
              <Link onClick={openNav} to="/pricing">
                Pricing
              </Link>
            </li>
            {/* <li>
              <Link onClick={openNav} to="/models">
                Models
              </Link>
            </li> */}
            {/* <li>
              <Link onClick={openNav} to="/testimonials">
                Testimonials
              </Link>
            </li> */}
            {/* <li>
              <Link onClick={openNav} to="/team">
                Our Team
              </Link>
            </li> */}
            <li>
              <Link onClick={openNav} to="/contact">
                Contact
              </Link>
            </li>
            <li>
              <Link onClick={openNav} to="/about">
                About
              </Link>
            </li>
            {(auth.currentUser && ((auth.currentUser.email === "vrycue@gmail.com") || (auth.currentUser.email === "delunaphoebe06@gmail.com"))) &&       
            <li>
              <Link onClick={openNav} to="/bookings">
                Bookings
              </Link>
            </li>}
            <li>
            {              
              (auth.currentUser && auth.currentUser.email) ?                        
              <p>             
              <Link className="navbar__buttons__sign-in" onClick={handleLogout}>
                <div className="useraccount">
                <span>{auth.currentUser.displayName}</span> <IconLogout/>
                </div>
              </Link>    
                    
              </p>
              :
              <Link className="navbar__buttons__sign-in" onClick={handleLogin}>
                Sign In
              </Link>
            }
           </li>            
          </ul>
        </div>

        {/* desktop */}

        <div className="navbar">
          <div className="navbar__img">
            <Link className="logolink" to="/" onClick={() => window.scrollTo(0, 0)}>   
              <div className="navbar__logo">         
                <img src={Logo} alt="logo-img" />                
              </div>
            </Link> 
          </div>          
          <div className="navbar__txt">Quick Car Ride and Motor Rental</div>
          <ul className="navbar__links">
            <li>
              <Link className="home-link" to="/">
                Home
              </Link>
            </li>
            <li>
              {" "}
              <Link className="pricing-link" to="/pricing">
                Pricing
              </Link>
            </li>
            {/* <li>
              {" "}
              <Link className="models-link" to="/models">
                Vehicle Models
              </Link>
            </li> */}
            {/* <li>
              {" "}
              <Link className="testi-link" to="/testimonials">
                Testimonials
              </Link>
            </li> */}
            {/* <li>
              {" "}
              <Link className="team-link" to="/team">
                Our Team
              </Link>
            </li> */}
            <li>
              {" "}
              <Link className="contact-link" to="/contact">
                Contact
              </Link>
            </li>
            <li>
              {" "}
              <Link className="about-link" to="/about">
                About
              </Link>
            </li>
            {(auth.currentUser && ((auth.currentUser.email === "vrycue@gmail.com") || (auth.currentUser.email === "delunaphoebe06@gmail.com"))) &&
            <li>
              {" "}
              <Link className="team-link" to="/bookings">
                Bookings
              </Link>
            </li>
            }
          </ul>
          <div className="navbar__buttons">
            {              
              (auth.currentUser && auth.currentUser.email) ?                        
              <p>             
              <Link className="navbar__buttons__sign-in" onClick={handleLogout}>
                <div className="useraccount">
                <span>{auth.currentUser.displayName}</span> <IconLogout/>
                </div>
              </Link>    
                    
              </p>
              :
              <Link className="navbar__buttons__sign-in" onClick={handleLogin}>
                Sign In
              </Link>
            }
            {/* <Link className="navbar__buttons__register" to="/">
              Register
            </Link> */}
          </div>

          {/* mobile */}
          <div className="mobile-hamb" onClick={openNav}>
            <IconMenu2 width={30} height={30} />
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
